// extracted by mini-css-extract-plugin
export default {"ConfirmationPop":"FAQPop_ConfirmationPop__gsAV0","modalBody":"FAQPop_modalBody__SSHoT"};